module.exports = __webpack_public_path__ + "static/media/chiayi_logo.0964026f.svg";